import React from 'react';
import './index.scss';

const Footer = () => (
  <footer className="ol-footer" />
);

export default Footer;
